import { useContext } from "react";
import { VSFPLayout } from "./layout/VSFPLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

export const VSFP = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;
  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider>
        <RefProvider>
          <LocalStoreProvider>
            <VSFPLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
